export default {
  symptomatic_intracerebral: 'Symptomatic intracerebral',
  none: 'None',
  peripheral_bleeding: 'Peripheral bleeding requirements',
  angioedema: 'Angioedema',
  other: 'Other',
};



// WEBPACK FOOTER //
// ./src/components/SaeRecording/eventTypes.js